import { formatDate } from '@/lib/formatters/date'
import { ref } from 'vue'

import { useNextOrderStore } from '@/stores/nextOrder'
import { track } from '@/lib/track'

export const useNextOrderDelay = (rechargeId: string) => {
  const nextOrderStore = useNextOrderStore()

  const showDatePicker = ref(false)
  const changeDate = () => {
    showDatePicker.value = true
  }

  const confirmChangeDate = async (date: Date) => {
    showDatePicker.value = false
    if (nextOrderStore.order) {
      nextOrderStore.changeDate(
        rechargeId,
        formatDate('YYYY-MM-DD', nextOrderStore.order.scheduled_at),
        formatDate('YYYY-MM-DD', date),
      )
      track('next_order_change_date', {
        recharge_id: rechargeId,
        date: formatDate('YYYY-MM-DD', date),
        old_date: formatDate('YYYY-MM-DD', nextOrderStore.order.scheduled_at),
      })
    }
  }

  return {
    showDatePicker,
    changeDate,
    confirmChangeDate,
  }
}
